// src/pages/tournamentDetails/components/ChipDenominationsCard.js
import React from "react";

export default function ChipDenominationsCard({
  // data
  chips,

  // ui state
  chipValue,
  setChipValue,
  chipColor,
  setChipColor,

  // actions
  onAddChip,
  onRemoveChip,
  onSaveChips,
  savingChips,

  // permissions
  isAdmin,
  isCompleted,
}) {
  return (
    <div className="bg-zinc-900 p-4 rounded-lg border border-zinc-800 mb-8">
      <div className="flex items-center justify-between gap-4 mb-4">
        <h3 className="text-xl font-semibold text-[#B87333]">Chip Denominations</h3>

        {isAdmin && (
          <button
            onClick={onSaveChips}
            disabled={savingChips}
            className={`px-4 py-2 rounded font-semibold ${
              savingChips
                ? "bg-zinc-700 text-zinc-300 cursor-not-allowed"
                : "bg-green-700 hover:bg-green-800 text-white"
            }`}
          >
            {savingChips ? "Saving..." : "Save Chips"}
          </button>
        )}
      </div>

      {isAdmin && !isCompleted && (
        <div className="grid gap-3 md:grid-cols-3 items-end mb-6">
          <div>
            <label className="block text-zinc-300 text-sm mb-1">Value</label>
            <input
              type="number"
              className="w-full p-3 bg-zinc-800 text-zinc-100 rounded"
              placeholder="e.g. 100"
              value={chipValue}
              onChange={(e) => setChipValue(e.target.value)}
            />
          </div>

          <div>
            <label className="block text-zinc-300 text-sm mb-1">Color</label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                className="h-12 w-16 rounded bg-zinc-800 border border-zinc-700"
                value={chipColor}
                onChange={(e) => setChipColor(e.target.value)}
              />
              <input
                type="text"
                className="flex-1 p-3 bg-zinc-800 text-zinc-100 rounded"
                value={chipColor}
                onChange={(e) => setChipColor(e.target.value)}
              />
            </div>
          </div>

          <button
            onClick={onAddChip}
            className="px-4 py-3 rounded font-semibold bg-[#B87333] hover:bg-[#A46230] text-zinc-950"
          >
            + Add Chip
          </button>
        </div>
      )}

      {chips.length === 0 ? (
        <p className="text-zinc-400">No chips added yet.</p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {chips
            .slice()
            .sort((a, b) => Number(a.value) - Number(b.value))
            .map((c) => (
              <div
                key={c.value}
                className="p-4 rounded border border-zinc-800 bg-zinc-950 flex items-center justify-between"
              >
                <div className="flex items-center gap-3">
                  <div
                    className="h-10 w-10 rounded-full border border-zinc-700"
                    style={{ backgroundColor: c.color }}
                    title={c.color}
                  />
                  <div>
                    <p className="text-zinc-100 font-semibold">{c.label}</p>
                    <p className="text-zinc-400 text-sm">
                      Value: {Number(c.value).toLocaleString()}
                    </p>
                  </div>
                </div>

                {isAdmin && !isCompleted && (
                  <button
                    onClick={() => onRemoveChip(c.value)}
                    className="px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white font-semibold"
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}